import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceClientService } from 'src/app/services/service-client.service';
import { environment } from 'src/environments/environment';
import { Response } from 'src/app/models/user';

export interface LayoutApp {
  package: string;
  version: string;
  minVersion: string;
  maxVersion: string;
}

export interface LayoutCondition {
  type: string; // CHILD_COUNT, CLASS_NAME, TEXT_MATCH, CHILDREN, LIST, LAYOUT, OR, NOT, META
  description?: string;
  min?: number;
  max?: number;
  values?: string[];
  index?: number;
  indices?: number[];
  exact?: boolean;
  className?: string;
  classNames?: string[];
  regex?: string;
  reverseSearch?: boolean;
  target?: LayoutCondition[];
  conditions?: LayoutCondition[];
  item?: string;
  items?: string[];
  itemClassName?: string;
  minSize?: number;
  layout?: string;
  ignoreConditions?: number[];
  condition?: LayoutCondition;
  ref?: {
    tag?: string;
    index?: number;
    relativeIndex?: number;
    context?: string;
    regex?: string;
    valueRegex?: string;
  };
}

export interface Layout {
  layoutType: string;
  priority: number;
  critical: boolean;
  alertProbability: number;
  contextType?: string;
  screenContext?: string;
  conditions: LayoutCondition[];
  previousLayouts: string[];
  subLayouts?: { [key: string]: LayoutCondition[] };
}

export interface CreateLayoutPayload {
  apps: LayoutApp[];
  layouts: Layout[];
  version: number;
  companyId?: string;
  agencyId?: string;
  userId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  constructor(private serviceClientService: ServiceClientService) {}

  getAll(options: { page: number; limit: number; search?: string }): Observable<Response<any>> {
    let params = new HttpParams()
      .set('page', options.page.toString())
      .set('limit', options.limit.toString());

    if (options.search) {
      params = params.set('search', options.search);
    }

    return this.serviceClientService.get<Response<any>>(environment.endPoints.getLayouts, params);
  }

  createLayout(payload: CreateLayoutPayload): Observable<Response<any>> {
    return this.serviceClientService.post<CreateLayoutPayload, Response<any>>(
      environment.endPoints.uploadLayout,
      payload
    );
  }

  updateLayout(id: string | number, payload: CreateLayoutPayload): Observable<Response<any>> {
    const endpoint = `${environment.endPoints.updateLayout}/${id}`;
    return this.serviceClientService.post<CreateLayoutPayload, Response<any>>(endpoint, payload);
  }

  deleteLayout(id: string | number): Observable<Response<any>> {
    const endpoint = `${environment.endPoints.deleteLayout}/${id}`;
    return this.serviceClientService.delete<Response<any>>(endpoint);
  }
}

